/** Fills every {name} placeholder in a translated string. */
export function fill(
    text: string,
    values: Record<string, string | number>
): string {
    return Object.entries(values).reduce(
        (out, [key, value]) => out.split(`{${key}}`).join(String(value)),
        text
    )
}
